import { pickKeys } from '@sportworld/js-sdk/src/utils/utils'

import { reducedPageKeys } from '@/constants/page'
import { ApiService } from '@/service'
import { ReducedPageType } from '@/types/servicesTypes/pageTypes'

export const getReducedFavoritePages = async (favoritePageIds: string[]) => {
  try {
    const favoritePages = await ApiService.getBatchPages(favoritePageIds)

    if (!favoritePages?.length) {
      return
    }

    const reducedPages = favoritePages.reduce<Record<string, ReducedPageType>>(
      (pages, page) => {
        pages[page.id] = pickKeys(page, reducedPageKeys)

        return pages
      },
      {},
    )
    return reducedPages
  } catch (e) {
    return Promise.reject(e)
  }
}
